import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FormControl, TextField, Grid, Button, MenuItem, InputLabel, Select } from '@mui/material/';
import { Typography, Box, Toolbar, Dialog, DialogTitle, DialogContent, DialogActions, Link, ButtonGroup } from '@mui/material/';
import { borders } from '@mui/system';

import moment from 'moment';
import Cookies from 'js-cookie'

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import parsePhoneNumber from 'libphonenumber-js'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import FormLabel from '@mui/material/FormLabel';
import Autorize from '../../components/ui/autorize';
import RadioVF from '../../components/ui/radio';



import { getSessionValide, getUserRule, setSession, getSessionExpirer, getIsAdmin } from '../../utils/userRule';


function Member({ memberid, clubid, secteur, ruleWrite }) {



    /*
       const MyAxios = axios.create({
           headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
           withCredentials: true,
           xsrfCookieName: 'token',
           xsrfHeaderName: 'X-XSRF-TOKEN',
       })*/
    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })


    const [minDateAdesion, setMinDateAdesion] = useState(new Date());
    const [sessionValide, setSessionValide] = useState("");
    const [deleteList, setDeleteList] = useState();
    const [errorAxios, setErrorAxios] = useState("false");
    const [ruleRead, setRuleRead] = useState(false);
    const [modalHyperlinkNewMember, setmodalHyperlinkNewMember] = useState(false);
    const [isActif, setIsActif] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    const [state, setState] = React.useState({

        editmode: "",
        MemberTable: {
            clubid: clubid, memberid: "", First_Name: "",
            Last_Name: "", E_Mail_Address: "", Cell_Phone_Number: "",
            Birth_Date: "", Business_Phone_Number: "", Home_Phone_Number: "",
            Title: "", DateAdded: "", DateDeleted: "",
            DateEffective: "", DateReceived: "", Date_Changed: "", State_Province_Code: "", Postal_Code: "",
            Address: "", City: "", Delete_Code: "",
            Delete_Reason: "", FOO_ClubNbr: "", Life_Member_Status: "", Member_Roster_Number: "",
            Sponsored_By_Club_Number: "", Sponsored_By_Roster_Number: "",
            CollegeMbr: "", Address_Questionable_Flag: "", Address_Type: "",
            Address_Valid_Flag: "", Advertisement_Flag: "",
            Charter_Member_Flag: "", Free4for1Mbr: "",
            HighFiveMbr: "", Magazine_Flag: "", NewMbrType: "", New_Member_Kit: "", individual_member: "",
           
        },
    });


    useEffect(() => {

        setMinDateAdesion(moment().startOf('month').format('YYYY-MM-DD'));

        const fetchData = async () => {
            try {
                setIsAdmin(await getIsAdmin());
                let read_member = await getUserRule("read_member", clubid, secteur);
                setRuleRead(read_member);

                setSessionValide(getSessionExpirer());

                //setFormValue(clubid,props.clubid);
                //setState({clubid: props.clubid});           
                // setState({ ...state, "addressId": idAddress});

                if (read_member) {
                    LoadDeleteList();
                    if (memberid !== "new")
                        LoadMembre(memberid, clubid);
                    else {
                        MyAxios.get(process.env.REACT_APP_API + "/members/getNextMemberNumber/" + clubid)
                            .then((res) => {
                                setErrorAxios(false);
                                console.log("load edit row ------" + res.data);

                                let items = state.MemberTable;
                                items["FOO_ClubNbr"] = clubid;
                                items["memberid"] = 'new';
                                items["fk_club_master"] = clubid;
                                items["fk_status"] = "A";

                                items["Member_Roster_Number"] = res.data[0][0]['Member_Roster_Number'];

                                setState({
                                    ...state, "MemberTable": items,
                                });

                            })
                            .catch((error) => {
                                setErrorAxios(true);
                                console.log("ERROR load id " + memberid + " ------>" + error);
                            });
                    }
                }
            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };
        fetchData(); // Appel de la fonction asynchrone


    }, [memberid, clubid]);


    function ValidateEmail(inputText) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (inputText.match(mailformat)) {
            // alert("Valid email address!");
            // document.form1.text1.focus();
            return true;
        }
        else {
            // alert("You have entered an invalid email address!");
            // document.form1.text1.focus();
            return false;
        }
    }


    //************************************* DATE */*********************************** */ */
    //************************************************************************************ */
    const handleChangeDateBirth = (newValue) => {
        var d = formatDateMonthDay(newValue);
        let items = state.MemberTable;
        items["Birth_Date"] = d;
        setState({
            ...state, "MemberTable": items,
        });
    };


    const handleChangeDateEffective = (newValue) => {
        var d = formatDate(newValue);
        let items = state.MemberTable;
        items["DateEffective"] = d;
        setState({
            ...state, "MemberTable": items,
        });
    };


    const handleChangeDateDeleted = (newValue) => {
        var d = formatDate(newValue);
        let items = state.MemberTable;
        items["DateDeleted"] = d;
        setState({
            ...state, "MemberTable": items,
        });
    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    function formatDateMonthDay(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [month, day].join('-');
    }

    //************************************************************************************ */
    //************************************************************************************ */




    function handleChange(event) {
        var value = event.target.value;
        console.log(event.target.id + " == ", event.target.value);
        let items = state.MemberTable;

        if (event.target.id === "Home_Phone_Number" || event.target.id === "Cell_Phone_Number" || event.target.id === "Business_Phone_Number") {
            const phoneNumber = parsePhoneNumber(value, 'CA')
            if (phoneNumber) {
                console.log(phoneNumber.isPossible());
                value = phoneNumber.formatNational();
            }

        }

        if (event.target.id === "Postal_Code") {
            var regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
            var match = regex.exec(value);
            if (match) {
                if (value.indexOf("-") !== -1)
                    value = value.replace("-", " ");

                if (value.length == 6) {
                    value = value.substr(0, 3) + " " + value.substr(3, 6);
                }
                value = value.toUpperCase();
                console.log("codepostal valide");

            } else {
                console.log("codepostal invalide");
            }
        }


        items[event.target.id] = value;
        setState({
            ...state, "MemberTable": items,
        });
    }


    function handleChangeSelectSalutation(event) {
        const value = event.target.value;
        let items = state.MemberTable;
        items["Title"] = value;
        setState({
            ...state, "MemberTable": items,
        });
    }



    function handleChangeSelectProvince(event) {
        const value = event.target.value;
        let items = state.MemberTable;
        items["State_Province_Code"] = value;
        setState({
            ...state, "MemberTable": items,
        });
    }



    function handleChangeDeleteCode(event) {
        const value = event.target.value;
        let items = state.MemberTable;
        items["Delete_Code"] = value;
        setState({
            ...state, "MemberTable": items,
        });
    }


    function LoadDeleteList() {
        MyAxios.get(process.env.REACT_APP_API + "/lookup/getdeletemember/")
            .then((res) => {
                setDeleteList(res.data);
            })
            .catch((error) => {

                console.log("ERROR load delete list ------>" + error);
            });

    }


    function LoadMembre(memberid, clubid) {

        MyAxios.get(process.env.REACT_APP_API + "/members/club/" + clubid + "/secteur/" + secteur + "/getmember/" + memberid)
            .then((res) => {

                console.log("load edit row ------" + res.data);
                setState({ ...state, MemberTable: res.data[0] });

                if (res.data[0].DateDeleted != null)
                    setIsActif(false);

                setErrorAxios(false);

            })
            .catch((error) => {
                setErrorAxios(true);
                console.log("ERROR load id " + memberid + " ------>" + error);
            });

        console.log("Recherche:" + memberid);

    }


    function closeModalHyperlinkNewMember() {

        window.open('https://membres.optimiste.org/produit/cotisation-nouveau-membre-ofc', '_blank');
        setmodalHyperlinkNewMember(false);
    }

    function ReactiverChange() {

        MyAxios.get(process.env.REACT_APP_API + "/members/reactiver/" + state.MemberTable.id)
            .then((res) => {
                alert("save complete");
                LoadMembre(memberid, clubid);
            })
            .catch((error) => {
                setErrorAxios(true);
                console.log("ERROR load id " + memberid + " ------>" + error);
            });

    }

    function SaveChange() {


        let myDAteEffectiveEntrez = moment(state.MemberTable.DateEffective, "YYYY-MM-DD");
        if (memberid === "new") {
            //*** la date entrez doit être égale ou plus grande que le début du mois. */

            console.log(state.MemberTable.DateEffective);
            if (state.MemberTable.DateEffective === "") {
                alert("Il manque la date d'adhésion.");
                return;
            }

            if (moment(myDAteEffectiveEntrez).isAfter(minDateAdesion) || moment(myDAteEffectiveEntrez).isSame(minDateAdesion)) {

                if (state.MemberTable.State_Province_Code === "") {
                    alert("La province ne peut être vide.");
                    return;
                }
                if (!ValidateEmail(state.MemberTable.E_Mail_Address)) {
                    alert("Email invalide.");
                    return;
                }
            


                MyAxios.post(process.env.REACT_APP_API + '/members/add/', state.MemberTable, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((res) => {

                        console.log(res)
                        if (res.data === "") {

                            if (memberid == "new") {

                                alert("Sauvegarde complété, une facture à été généré automatiquement. Merci ");
                                // alert("Sauvegarde complété. ");
                                //setmodalHyperlinkNewMember(true);

                            }

                        }
                        else
                            alert("Erreur sauvegarde: " + res.data)

                    })
                    .catch((error) => {
                        console.log(error)
                        setErrorAxios(true);
                        alert("Erreur sauvegarde")
                    });
            }
            else {
                alert("La date d'adhésion ne doit pas être inférieur au mois courrant.");
                return;
            }

        }
        else {

            MyAxios.post(process.env.REACT_APP_API + '/members/set/' + memberid, state.MemberTable, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((res) => {
                    console.log(res)
                    if (res.status === 200)
                        alert("Sauvegarde complété")
                    else
                        alert("Erreur sauvegarde")

                })
                .catch((error) => {
                    console.log(error)
                    setErrorAxios(true);
                    alert("Erreur sauvegarde")
                });
        }
    }


    function getDisplayDate(Field) {
        if (memberid === "new") {
            return <TextField id={Field} value={state.MemberTable.Field} onChange={handleChange} label={Field} fullWidth />
        }
        else {
            return <TextField id={Field} value={state.MemberTable.Field} onChange={handleChange} label={Field} fullWidth />
        }
    }


    function StringMembreAVie() {
        if (state.MemberTable.Life_Member_Status === "O" ||
            state.MemberTable.Life_Member_Status === "1" ||
            state.MemberTable.Life_Member_Status === "A" ||
            state.MemberTable.Life_Member_Status === "F")
            return "Oui";
        else
            return "Non";
    }

 function StringIndividuelMembre() {
        if (state.MemberTable.individual_member === "T") // T pour  true
            return "Oui";
        else
            return "Non";
    }


    function getLiveMember() {

        if (isAdmin === true)
            return <Grid item xs={3} conainer  >
                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">Membre à vie</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={handleChange}
                            value={state.MemberTable.Life_Member_Status}
                        >

                            <FormControlLabel value="F" control={<Radio id="Life_Member_Status" />} label="Oui" />
                            <FormControlLabel value="N" control={<Radio id="Life_Member_Status" />} label="Non" />


                        </RadioGroup>
                    </FormControl>
                </Box>
            </Grid>;

        // }      



        return <Grid item xs={3} conainer  >
            <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                <Typography variant="h7" gutterBottom>Membre à vie: {StringMembreAVie()}   </Typography>
            </Box>
        </Grid>;


    }

    function getIndividualMember() {

        if (isAdmin === true)
            return <Grid item xs={3} conainer  >
                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">Membre individuel</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={handleChange}
                            value={state.MemberTable.individual_member}
                        >

                            <FormControlLabel value="T" control={<Radio id="individual_member" />} label="Oui" />
                            <FormControlLabel value="F" control={<Radio id="individual_member" />} label="Non" />


                        </RadioGroup>
                    </FormControl>
                </Box>
            </Grid>;

        // }      



        return <Grid item xs={3} conainer  >
            <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                <Typography variant="h7" gutterBottom>Membre individuel: {StringIndividuelMembre()}   </Typography>
            </Box>
        </Grid>;


    }
    


    /*
     <Grid item xs={2} container  > 
                        <TextField id="Search" value={state.MemberTable.Search} onChange={handleChange} label="Recherche 'Club-Membre'"   style={{ marginLeft: '10px',width:'300px' }}  />
                        </Grid> 
                      <Grid item xs={2} container  >   
                        <Button variant="containedFifth" onClick={recherche} >Recherche</Button>
                   </Grid> 
     */

    const shouldShowButton = state.MemberTable.DateDeleted && isActif === false && moment().diff(moment(state.MemberTable.DateDeleted), 'days') < 89;

    function SaveButton() {
        if (ruleWrite === true)
            return (<Grid item xs={12} sx={{ margin: 1 }}>

                <Button onClick={SaveChange} variant="containedFifth" sx={{ margin: '4px' }}>Enregistrer</Button>

                {shouldShowButton ?
                    <Button onClick={ReactiverChange} variant="containedFifth" sx={{ margin: '4px' }}  >Réactiver ce membre</Button>
                    : null}

            </Grid>);

        return
    }




    return (
        <div>
            <Autorize axiosError={errorAxios} sessionExpirer={sessionValide} ruleAcces={ruleRead} />
            {getMain()}
        </div>
    );


    function getMain() {

        if (ruleRead === true) {

            return (<div>
                <form>

                  



                        <Grid container spacing={2}>


                            <Grid item xs={9} container direction="column" >
                                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Membre</Typography>
                                    </Grid>

                                    <Grid container spacing={1}>

                                        <Grid item xs={4} >
                                            {memberid === "new" || isAdmin === true ?
                                                <TextField id="First_Name" value={state.MemberTable.First_Name} onChange={handleChange} label="Prénom" fullWidth />
                                                : <TextField id="First_Name" value={state.MemberTable.First_Name} disabled label="Prénom" fullWidth />
                                            }

                                        </Grid>
                                        <Grid item xs={4} >
                                            {memberid === "new" || isAdmin === true ?
                                                <TextField id="Last_Name" value={state.MemberTable.Last_Name} onChange={handleChange} label="Nom" fullWidth />
                                                : <TextField id="Last_Name" value={state.MemberTable.Last_Name} disabled label="Nom" fullWidth />
                                            }

                                        </Grid>
                                        <Grid item xs={4} >
                                            {memberid === "new" || isAdmin === true ?
                                                <FormControl sx={{ minWidth: 220 }}>
                                                    <InputLabel id="TitleLabel">Salutations</InputLabel>
                                                    <Select
                                                        labelId="TitleLabel"
                                                        id="Title"
                                                        value={state.MemberTable.Title}
                                                        label="Statut du club"
                                                        onChange={handleChangeSelectSalutation}
                                                    >
                                                        <MenuItem key={"name-sharedMNull"} value=""></MenuItem>
                                                        <MenuItem key={"name-sharedM"} value="M.">M.</MenuItem>
                                                        <MenuItem key={"name-sharedMme"} value="Mme">Mme</MenuItem>

                                                    </Select>
                                                </FormControl>

                                                : <TextField id="Title" value={state.MemberTable.Title} disabled label="Salutations" fullWidth />
                                            }
                                        </Grid>

                                    </Grid>
                                </Box>

                                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Adresse</Typography>
                                    </Grid>

                                    <Grid container spacing={1} >


                                        <Grid item xs={4}>
                                            <TextField id="Address" value={state.MemberTable.Address} onChange={handleChange} label="Adresse" fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField id="City" value={state.MemberTable.City} onChange={handleChange} label="Ville" fullWidth />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField id="Postal_Code" value={state.MemberTable.Postal_Code} onChange={handleChange} label="Code postal" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl sx={{ minWidth: 200 }}>
                                                <InputLabel id="State_Province_Code">Province du membre</InputLabel>
                                                <Select
                                                    labelId="State_Province_Code"
                                                    id="State_Province_Code"
                                                    value={state.MemberTable.State_Province_Code}
                                                    label="Province du club"
                                                    onChange={handleChangeSelectProvince}
                                                >

                                                    <MenuItem key={"name-shared" + "AB"} value="AB">Alberta</MenuItem>
                                                    <MenuItem key={"name-shared" + "BC"} value="BC">Colombie-Britannique</MenuItem>
                                                    <MenuItem key={"name-shared" + "PE"} value="PE">Île-du-Prince-Édouard</MenuItem>
                                                    <MenuItem key={"name-shared" + "MB"} value="MB">Manitoba</MenuItem>
                                                    <MenuItem key={"name-shared" + "NB"} value="NB">Nouveau-Brunswick</MenuItem>
                                                    <MenuItem key={"name-shared" + "NS"} value="NS">Nouvelle-Écosse</MenuItem>
                                                    <MenuItem key={"name-shared" + "ON"} value="ON">Ontario</MenuItem>
                                                    <MenuItem key={"name-shared" + "SK"} value="SK">Saskatchewan</MenuItem>
                                                    <MenuItem key={"name-shared" + "NL"} value="NL">Terre-Neuve-et-Labrador</MenuItem>
                                                    <MenuItem key={"name-shared" + "QC"} value="QC">Québec</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>


                                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Contact</Typography>
                                    </Grid>

                                    <Grid container spacing={1} >

                                        <Grid item xs={3} >
                                            <TextField id="Home_Phone_Number" value={state.MemberTable.Home_Phone_Number} onChange={handleChange} label="Téléphone maison" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField id="Cell_Phone_Number" value={state.MemberTable.Cell_Phone_Number} onChange={handleChange} label="Téléphone cellulaire" fullWidth />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextField id="E_Mail_Address" value={state.MemberTable.E_Mail_Address} onChange={handleChange} label="Courriel" fullWidth />
                                        </Grid>



                                    </Grid>
                                </Box>





                                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                    <Grid item>
                                        <Typography variant="h6" gutterBottom>Type d’adhésion</Typography>
                                    </Grid>
                                    <Grid container direction="row" spacing={1}>
                                        <Grid item xs={3} conainer  >
                                            <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                                <FormControl>
                                                    <FormLabel id="demo-row-radio-buttons-group-label">Étudiant</FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group"
                                                        onChange={handleChange}
                                                        value={state.MemberTable.CollegeMbr}
                                                    >
                                                        <FormControlLabel value="T" control={<Radio id="CollegeMbr" />} label="Oui" />
                                                        <FormControlLabel value="F" control={<Radio id="CollegeMbr" />} label="Non" />

                                                    </RadioGroup>
                                                </FormControl>
                                            </Box>

                                        </Grid>



                                        {getLiveMember()}

                                        {getIndividualMember()}


                                       

                                    </Grid>
                                </Box>



                            </Grid>


                          <Grid item xs={3} sx={{ position: 'relative' }}>
                                <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" gutterBottom>Date</Typography>
                                    </Grid>

                                    <Grid item xs={12} sx={{ margin: 1 }}>
                                        {memberid === "new" || isAdmin === true ?
                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>
                                                <DatePicker id="Birth_Date"
                                                    views={['month', 'day']}
                                                    label="Date de naissance (Mois-Jour)"
                                                    inputFormat="MM-DD"
                                                    value={state.MemberTable.Birth_Date}
                                                    onChange={handleChangeDateBirth}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            : <TextField id="Birth_Date" value={state.MemberTable.Birth_Date} disabled label="Date de naissance (Mois-Jour)" fullWidth />
                                        }

                                    </Grid>
                                    <Grid item xs={12} sx={{ margin: 1 }}>

                                        {memberid === "new" || isAdmin === true ?
                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>
                                                <DatePicker id="DateEffective"
                                                    views={['year', 'month', 'day']}
                                                    minDate={minDateAdesion}
                                                    label="Date d’adhésion"
                                                    inputFormat="YYYY-MM-DD"
                                                    value={state.MemberTable.DateEffective}
                                                    onChange={handleChangeDateEffective}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            : <Grid item xs={12} sx={{ margin: 0 }}>
                                                <TextField id="aa" value={state.MemberTable.DateEffective} disabled label="Date d’adhésion:" fullWidth />
                                            </Grid>
                                        }

                                    </Grid>
                                    <Grid item xs={12} sx={{ margin: 1 }}>

                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>
                                            <DatePicker id="DateDeleted"
                                                views={['year', 'month', 'day']}
                                                label="Date de radiation"
                                                inputFormat="YYYY-MM-DD"
                                                value={state.MemberTable.DateDeleted}
                                                onChange={handleChangeDateDeleted}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>

                                    </Grid>


                                </Box>

                                {state.MemberTable.DateDeleted !== null ?
                                    <Box sx={{ borderRadius: 3, padding: 2, margin: 2 }} style={{ border: "1px solid grey" }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" gutterBottom>Radiation</Typography>
                                        </Grid>

                                        <Grid item xs={12} sx={{ margin: 1 }}>

                                            <InputLabel id="Delete_Code-label">Raison</InputLabel>
                                            <Select
                                                labelId="Delete_Code-label"
                                                id="Delete_Code"
                                                value={state.MemberTable.Delete_Code}
                                                label="Delete_Code"
                                                onChange={handleChangeDeleteCode}
                                            >
                                                <MenuItem value={0}>N'a pas spécifié</MenuItem>
                                                <MenuItem value={1}>Non-paiement des cotisations</MenuItem>
                                                <MenuItem value={2}>Déménagé</MenuItem>
                                                <MenuItem value={3}>Décédé</MenuItem>
                                                <MenuItem value={4}>Démissionné</MenuItem>
                                                <MenuItem value={5}>Transfert</MenuItem>
                                                <MenuItem value={6}>Fusionné</MenuItem>
                                                <MenuItem value={7}>Manque d'intérêt</MenuItem>
                                                <MenuItem value={8}>Autre raison</MenuItem>
                                            </Select>


                                        </Grid>
                                        <Grid item xs={12} sx={{ margin: 1 }}>
                                            <TextField id="Delete_Reason" value={state.MemberTable.Delete_Reason} onChange={handleChange} label="Autre raison" fullWidth />
                                        </Grid>



                                    </Box>
                                    : null}


                              <Box sx={{ position: 'absolute', right: 16, bottom: 16 }}>
                                 {SaveButton()}
                               </Box>
 
                            </Grid>

                          

                        </Grid>
                     

                  



                </form>



                <Dialog key="DdialogCloseNewMember"
                    sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                    maxWidth="xs"
                    open={modalHyperlinkNewMember}
                >
                    <DialogTitle>Générer la facture</DialogTitle>
                    <DialogContent dividers>

                        <Typography variant="h8" gutterBottom>
                            Vous serez redirigé vers une page externe pour effectuer le paiement. Une fois votre paiement complété, vous recevrez une facture.
                        </Typography>

                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeModalHyperlinkNewMember}>OK
                        </Button>

                    </DialogActions>
                </Dialog>


            </div>

            );
        }

    }

}

export default Member;